// VIBRANIAM-SPACE v2 - wasm.js
// Carica i moduli Emscripten serviti da /wasm/.
//
// I file stanno in public/, quindi Vite non deve provare a risolverli come
// moduli del progetto: in dev rifiuta gli import che puntano dentro public/.
// Si evita costruendo una URL assoluta completa (con origin), che Vite lascia
// passare come risorsa esterna.

let cache = {};

function wasmUrl(name) {
  const base = (import.meta.env && import.meta.env.BASE_URL) || '/';
  const rel = `${base.replace(/\/$/, '')}/wasm/${name}.mjs`;
  if (typeof window !== 'undefined' && window.location) {
    return new URL(rel, window.location.origin).href;
  }
  return rel;
}

export function loadWasmModule(name) {
  if (cache[name]) return cache[name];
  cache[name] = (async () => {
    const url = wasmUrl(name);
    const mod = await import(/* @vite-ignore */ url);
    const factory = mod.default;
    if (typeof factory !== 'function') {
      throw new Error(`${name}.mjs non esporta una factory`);
    }
    return factory();
  })();
  return cache[name];
}

export const loadParticleField = () => loadWasmModule('particle-field');
export const loadAudioAnalyzer = () => loadWasmModule('audio-analyzer');
export const resetWasmCache = () => { cache = {}; };
